/*

	Site Development by Digital Interactive


	Developers:
		Jeff_Williams(jwill10s)
		Braden_Witherwax(radenB)

*/


var winWidth, winHeight;


var CONTROLLER = new ScrollMagic.Controller()

$(document).ready( function() {
	var page = document.getElementById('page')

	var SEARCH = document.getElementById('search')
	var searchBar = document.getElementById('search-bar')
	var mobileIcon = document.getElementById('mobile-menu-icon')
	var primaryMenu = document.getElementById('primary-menu')
	var mobileClose = document.getElementById('mobile-menu-close')

	var header = document.getElementById('masthead')
	var mainMenu = header.getElementsByClassName('site-branding')[0]

	var headerTL = new TimelineMax()
	var triggerHook = winWidth > 768 ? (100 / window.innerHeight) : 0

	var headerH = document.getElementById('top-bar').clientHeight
	var headerToMove = headerH * .5

	headerTL.to(mainMenu, 0.35, {y: '-' + (headerH - headerToMove), ease: Power2.easeOut})
			.to(header, 0.25, {y: '-' + headerToMove + 'px', ease: Power2.easeOut}, '-=0.3')

	var headerScene = new ScrollMagic.Scene({
		triggerElement: page,
		triggerHook:0
	})
	.on('start', (e) => {
		if (e.state == 'DURING') {
			searchBar.classList.add('adjusted')
		}
		else {
			searchBar.classList.remove('adjusted')
		}
	})
	.setTween(headerTL)
	.addTo(CONTROLLER)
	// .addIndicators()

	// ----- Mobile Menu -----

	mobileIcon.addEventListener('click', () => {
		mobileIcon.classList.toggle('opened')

		if (mobileIcon.classList.contains('opened')) {
				primaryMenu.classList.add('opened')
				mobileClose.classList.add('show')
		}
		else {
			primaryMenu.classList.remove('opened')
			mobileClose.classList.remove('show')
		}
	})

	mobileClose.addEventListener('click', () => {
		mobileClose.classList.remove('show')
		mobileIcon.classList.remove('opened')
		primaryMenu.classList.remove('opened')
	})

	// ----- SEARCH -----
	TweenMax.set(searchBar, {y: '-300px'})

	SEARCH.addEventListener('click', () => {
		SEARCH.classList.toggle('opened')

		SEARCH.classList.contains('opened') ?
			TweenMax.to(searchBar, 0.3, {y: '0px'})
		: TweenMax.to(searchBar, 0.3, {y: '-300px'})
	})

	var UP = document.getElementById('UP-UP-AND-AWAY')

	UP.addEventListener('click', (e) => {
		e.preventDefault()
		TweenMax.to(window, 0.35, {scrollTo: 0, ease: Power2.easeOut})
		// body.animate({ scrollTop: 0 }, "slow")
	})


})

// WINDOW RESIZE FUNCTIONS -----------------------
$(window).on('resize', function() {
	winWidth = $(window).width();
	winHeight = $(window).height();
})



// WEBPACK FOOTER //
// ./src/js/main.js